import { useRef} from "react";
import { useSelector, useDispatch } from "react-redux";
import ColorBox from "./ColorBox";
import { LoadingSvg } from "../../icons/Icon";
import { Loading } from "../Loaders";
import Input from "../components/Input";
import InputWrapper from "../components/InputWrapper";
import { SelectOptionsSection } from "../../widgets/MultiSelectOptions";
import { $serializeForm } from "../../main";
import { useEventContext } from "../../contexts/EventContextProvider";
import { iconsMap } from "../../icons/iconsMap";
import { cancelTagGroupCrudFromEvent, saveTagGroupEvent, deleteTagGroupEvent } from "../../events/TagGroupEvents";


const getOptions = (tags) => {
    return Array.isArray(tags) ? tags.map(tag => ({ value: `${tag.id}-${tag.name}`, label: tag.name })) : [];
}
const getSelected = (tags) => {
    return Array.isArray(tags) ? tags.map(tag => ({ value: `${tag.id}-${tag.name}`, label: tag.name })) : [];
};
const TagGroupInputBar = (p) => {

    const form = useRef(null);
    const tags = useSelector((state) => state.base.tags);
    const tagGroups = useSelector((state) => state.base.tagGroups);
    const { state, eventDispatch } = useEventContext();
    const dispatch = useDispatch();

    const actionClass = {
        edit: 'CollectionInputBar_controls_edit',
        save: 'CollectionInputBar_controls_edit',
        create: 'CollectionInputBar_controls_create',
        delete: 'CollectionInputBar_controls_delete',
    };
    const onSelectChange = (e) => {

    }

    const onCancel = (e) => {
        eventDispatch(cancelTagGroupCrudFromEvent());
    };
    const onSave = (e) => {
        const [encoded, json] = $serializeForm(form.current);
        const type = state?.tagGroupCrud?.meta?.type;
        
        if (type == 'delete') {
            eventDispatch(deleteTagGroupEvent(json, dispatch, tagGroups));
        } else {
            eventDispatch(saveTagGroupEvent(json, dispatch, tagGroups));
        }
    };

    const render = (p, m) => (
        <div className="CollectionInputBar">
            <div className="CollectionInputBar_header">
                <h6 className="CollectionInputBar_title">
                    {iconsMap[m.type]}<span>{m.title}</span>
                    <em>{p?.name || ''}</em>
                </h6>
                <div className="CollectionInputBar_controls">
                    <button onClick={onCancel} className="CollectionInputBar_controls_cancel">cancel</button>
                    {(m?.button) ?
                        <button onClick={onSave} className={actionClass[m?.type]} >{m?.button}</button> :
                        <></>}
                </div>
            </div>
            <form ref={form}>
                <div className="CollectionInputBar_body">
                    <div className="flex-column">
                        <div className="flex-row">
                            <input type="hidden" name="id" value={p?.id || ''} />
                            <div className="col-4">
                                <Input label={'name'} value={`${p?.name || ''}`} placeholder={'name'} />
                            </div>
                            <div className="col-16">
                                <Input label={'description'} value={`${p?.description || ''}`} placeholder={'description'} />
                            </div>
                            <div className="col-4">
                                <ColorBox value={`${p?.color || ''}`} />
                            </div>
                        </div>
                        <div className="flex-row">
                            <div className="col-24">
                                <InputWrapper label={'selected tags'}>
                                    <SelectOptionsSection
                                        name='tags[]'
                                        multiple={true}
                                        options={getOptions(tags)}
                                        selected={getSelected(p?.tags || [])}
                                        //onChange={onSelectChange}
                                        className={''}
                                    />
                                </InputWrapper>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );

    const renderCase = (state, render) => {
        switch (state?.status) {
            case 'LOADING':
                return <Loading><LoadingSvg /></Loading>;
            case 'DONE':
                return render(state.payload, state.meta);
            case 'ERROR':
                return <></>;
            default:
                return <></>;
        }
    }

    return renderCase(state.tagGroupCrud, render);
};

export default TagGroupInputBar;